<div class="header">
    <h2>{{ 'admins.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="admins-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'admins.error.unavailable' | translate" />
} @else if (admin(); as admin) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'admins.fieldset.personal' | translate }}</h2>
            <div class="row">
                <app-form-input
                    [control]="form.controls.firstName"
                    [label]="'admins.form.firstName' | translate"
                    inputId="firstName"
                    testId="admins-edit-first-name"
                />
                <app-form-input
                    [control]="form.controls.lastName"
                    [label]="'admins.form.lastName' | translate"
                    inputId="lastName"
                    testId="admins-edit-last-name"
                />
            </div>
            <app-form-input [control]="form.controls.email" [label]="'admins.form.email' | translate" type="email" inputId="email" testId="admins-edit-email" />
        </div>
    </form>

    <div class="footer">
        <p-button [label]="'admins.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="admins-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'admins.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="admins-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
